import App from "./App.svelte";
// http://local-topup-api.topupbar.com:3500/oauth?app_id=290BOWcKF4xX7rnYs1as2trsiDH&redirect_url=http%3A%2F%2Flocal-prepaid.topupbar.com%3A3000
const app = new App({
    target: document.body,
    props: {
        name: "world",
    },
});
export default app;
